module.exports = __webpack_public_path__ + "img/about-b-slide1.22c6f048.jpg";